/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Start } from "../../commons/types/Start";
import { End } from "../../commons/types/End";
export const AgentStats = core.serialization.object({
    start: Start,
    end: End,
    executions: core.serialization.number(),
    succeeded: core.serialization.number(),
    failed: core.serialization.number(),
});
